import { render, staticRenderFns } from "./ConfirmationExtract.vue?vue&type=template&id=15f64ee0"
import script from "./ConfirmationExtract.vue?vue&type=script&lang=js"
export * from "./ConfirmationExtract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports